// extracted by mini-css-extract-plugin
export default {"fr-view":"CourseCard_fr-view__+ZfwU","container":"CourseCard_container__q+Q+x","icon":"CourseCard_icon__kdG2J","title":"CourseCard_title__H2ClY"};